// shared-types/src/accountEmailDomain/types.ts

export enum AccountEmailDomainStatus {
  PENDING = 'PENDING',
  DNS_PENDING = 'DNS_PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface AccountEmailDomain {
  id: string;
  accountId: string;
  accountDomainId: string;
  domain: string;
  status: AccountEmailDomainStatus;
  activatedAt: Date | null;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
}
